import { render, staticRenderFns } from "./DataNumber.vue?vue&type=template&id=452367d4&scoped=true"
import script from "./DataNumber.vue?vue&type=script&lang=js"
export * from "./DataNumber.vue?vue&type=script&lang=js"
import style0 from "./DataNumber.vue?vue&type=style&index=0&id=452367d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452367d4",
  null
  
)

export default component.exports